import { Component, OnInit, Inject, AfterViewInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'moneris-checkout-form',
	templateUrl: './moneris-checkout-form.component.html',
	styles: []
})

export class MonerisCheckoutFormComponent implements OnInit {

	@Input('profile') profile: any;
	@Input('orderRefNumber') orderRefNumber: string;
	@Input('selectedOrderKey') selectedOrderKey: string;
	@Input('clientKey') clientKey: string;
	@Output() closer = new EventEmitter();

	public sessionTicket: string | null = null;
	public enviroMode: string | null = null;
	public responseEvent: string | null = null;

	constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef) { } //, public router: Router

	ngOnInit(): void {
		this.enviroMode = (this.profile?.params?.find((f: any) => { return f.name == 'enviroMode' })?.value) ?? 'qa';
		this.sessionTicket = (this.profile?.params?.find((f: any) => { return f.name == 'ticket' })?.value) ?? 'NotSet';
	}

	ngAfterViewInit() {

		const api = this.document.createElement('script');
		api.type = 'text/javascript';
		api.src = environment.mcoApiScriptUrl;
		this.elementRef.nativeElement.appendChild(api);
		const s = this.document.createElement('script');
		s.type = 'text/javascript';
		s.text = 
		'function onMCOPageLoad(response) {' +
		'let responseMessage = document.getElementById("responsemessage"); responseMessage.value = (response);' +
		'responseMessage.click();' +
		'}' +
		'function onMCOProcessComplete(response) {' +
		'let responseMessage = document.getElementById("responsemessage"); responseMessage.value = (response);' +
		'responseMessage.click();' +
		'mcoCheckout.closeCheckout();' +
		'mcoCheckoutDiv.style.position = "fixed";' +
		'mcoCheckoutDiv.style.zIndex = "0";' +
		'mcoCheckoutDiv.style.width = "0px";' +
		'mcoCheckoutDiv.style.height = "0px";' +
		'mcoCheckoutDiv.style.minWidth = "0px";' +
		'mcoCheckoutDiv.style.minHeight = "0px";' +
		'}' +
		'var mcoCheckout = null;' +
		'var mcoCheckoutDiv = document.getElementById("monerisCheckout");' + 
		'function setupMCO() {' +
		'mcoCheckout = new monerisCheckout();' +
		'mcoCheckout.setMode("' + this.enviroMode + '");' +
		'mcoCheckout.setCheckoutDiv("monerisCheckout");' +
		'mcoCheckout.setCallback("page_loaded", onMCOPageLoad);' +
		'mcoCheckout.setCallback("cancel_transaction", onMCOProcessComplete);' +
		'mcoCheckout.setCallback("error_event", onMCOProcessComplete);' +
		'mcoCheckout.setCallback("payment_receipt", onMCOProcessComplete);' +
		'mcoCheckout.setCallback("payment_complete", onMCOProcessComplete);' +
		'mcoCheckout.startCheckout("' + this.sessionTicket + '");' + 
		'mcoCheckoutDiv.style.position = "fixed";' +
		'mcoCheckoutDiv.style.zIndex = "1001";' +
		'}' + 
		'setTimeout(function(){ document.getElementById("process").style.color = "#FFFFFF"; document.getElementById("process").style.background = "#00677F"; }, 1000);' +
		'setTimeout(setupMCO, 100);'
		;

		this.elementRef.nativeElement.appendChild(s);
	}

	public handleMOCEvent(responseMessage: string) {
		var response = JSON.parse(responseMessage);
		switch (response.handler) {
		case 'page_loaded':
			{
				break;
			}
		case 'cancel_transaction':
			{
				this.close(true, '914', response.ticket);
				break;
			}
		case 'error_event':
		case 'payment_receipt':
		case 'payment_complete':
			{
				this.close(false, response.response_code, response.ticket);
				break;
			}
		}
	}

	private close(cancel: boolean, response_code: string, ticket: string) {
		this.closer.emit({ cancelTxn: cancel, mcoClientKey: this.clientKey, mcoProcName: this.profile.processorName?.toLowerCase(), mcoInvoiceId: this.selectedOrderKey, mcoInvoiceNumber: this.orderRefNumber, response_order_id: ticket, response_code: response_code });
	}
}

/**

	success
	ticket
	result

**/